
import { useState, useEffect } from 'react';
import { setupCipherResultsTable, setupInitiatedBrosTable } from '@/lib/supabaseSetup';

export const useInitiationSetup = () => {
  const [tableSetupDone, setTableSetupDone] = useState<boolean>(false);

  useEffect(() => {
    const setupDatabase = async () => {
      try {
        // Setup both tables
        const [cipherSuccess, brosSuccess] = await Promise.all([
          setupCipherResultsTable(),
          setupInitiatedBrosTable()
        ]);
        
        const success = cipherSuccess && brosSuccess;
        setTableSetupDone(success);
        
        if (success) {
          console.log("Supabase tables are ready");
        } else {
          console.warn("Failed to setup one or more Supabase tables");
        }
      } catch (error) {
        console.error("Error during Supabase setup:", error);
      }
    };
    
    setupDatabase();
  }, []);

  return { tableSetupDone };
};
